import { AccountDetailForSelector } from '@varo/graphql-schema-types';
import React from 'react';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import { ListItemLeadingAccessoryProps } from 'shared/components/vxl/ListItem/ListItemLeadingAccessory';
import { VXLComponentId } from 'shared/renderer/types';

interface PaymentAccountRowProps {
  account: AccountDetailForSelector;
  secondaryCopy: string;
  isDisabled?: boolean;
  onPress?: () => void;
}

export const listItemLeadingAccessory = (
  account: AccountDetailForSelector,
): ListItemLeadingAccessoryProps => ({
  id: VXLComponentId.ICON_AVATAR,
  name: VXLComponentId.ICON_AVATAR,
  props: {
    variant: 'MD',
    imageSource: { uri: account.iconURL },
  },
});

const PaymentAccountRow = ({
  account,
  secondaryCopy,
  isDisabled = false,
  onPress,
}: PaymentAccountRowProps) => {
  return (
    <ListItem
      primaryCopy={`${account.name} • ${account.accountNumberLast4}`}
      secondaryCopy={secondaryCopy}
      leadingAccessory={listItemLeadingAccessory(account)}
      isDisabled={isDisabled}
      showsChevron={false}
      onPress={onPress}
    />
  );
};

export default PaymentAccountRow;
